export default {
  listasituacaoAtendimentos: [],
  situacaoAtendimento: {
    id: null,
    descricao: '',
    ativo: true,
  },
}
